import { useComponent } from '@/utils/utils';
import Compo from './index.vue';

/**
 *
 * @param {{}} data
 */
export function useDialog(data) {
  const compo = useComponent(
    {
      name: 'NDialog',
      methods: {
        showLoading() {
          this.$refs.dialogRef?.showLoading();
        },
        hideLoading() {
          this.$refs.dialogRef?.hideLoading();
        },
        refresh() {
          this.$refs.dialogRef?.refresh();
        }
      },
      render(_h) {
        const { slots, ...props } = data;

        return (
          <Compo ref="dialogRef" props={props}>
            {slots.default()}

            {slots?.footer?.()}
          </Compo>
        );
      },
      mounted() {
        data?.onMounted?.();
      },
      beforeDestroy() {
        data?.onBeforeDestroy?.();
      }
    },
    {}
  );

  return compo.$mount();
}
